import { BrandTheme, resolveBrandTheme } from '@gms/themes';
import type { Vuetify2Theme } from '@gms/vuetify2-themes';
import { defineStore } from 'pinia';
import { computed, ref, watchEffect } from 'vue';
import { useConfigStore } from './config';


export const useThemeStore = defineStore('theme', () => {
  const configStore = useConfigStore();
  const lsTheme = localStorage.getItem('theme');
  const theme = ref<Vuetify2Theme>(lsTheme ? JSON.parse(lsTheme) : undefined);
  watchEffect(() => {
    localStorage.setItem('theme', JSON.stringify(theme.value))
    if (configStore.config) {
      configStore.config.theme = theme.value
    }
  })
  const brandTheme = computed<BrandTheme | undefined>(() => {
    if (theme.value) {
      return resolveBrandTheme(theme.value);
    }

    if (configStore.config === undefined || configStore.config === null) {
      return undefined
    }

    if ('themeTokens' in configStore.config && configStore.config?.themeTokens) {
      return configStore.config.themeTokens as BrandTheme;
    }

    if (configStore.config?.theme) {
      return resolveBrandTheme(configStore.config.theme);
    }

    return undefined;
  });
  const dark = ref(false)

  return { theme, brandTheme, dark }
});
